<template>
    <div
        :class="[className, { error: blured && focused != true && hasError }]"
        :style="{ 'max-width': isDatetime && !isMobile ? '200px' : 'unset' }"
    >
        <span @blur="handleBlur" class="input-component-datetime" v-if="isDatetime" :id="id" :name="name">
            <Datepicker
                locale="ru"
                v-model="internalValueDateTime"
                :min-date="new Date()"
                cancelText="X"
                selectText="Выбрать"
                hide-input-icon
            >
                <template #action-preview="{ value }">
                    {{ tools.prettyDateTime(value) }}
                </template>
            </Datepicker>
            <label class="input-component-datetime-date">{{
                internalValueDate ? tools.datePrettyText(internalValueDate) : 'Дата и время'
            }}</label>
            <label class="input-component-datetime-time">{{
                internalValueTime ? tools.timePrettyText(internalValueDate, internalValueTime) : ''
            }}</label>
            <img class="input-component-datetime-ico" src="@/assets/IMGS/SVG/calendar_green.svg" />
        </span>

        <input
            v-else-if="isTextInput"
            :type="inputType"
            :id="id"
            :name="name"
            v-model="internalValue"
            :placeholder="placeholder"
            @change="handleChange"
            @input="handleInput"
            @focus="handleFocus"
            @blur="handleBlur"
            @click="onClick"
            ref="input"
            :disabled="isDisabled"
            required
        />

        <textarea
            v-else
            :id="id"
            :name="name"
            :rows="rows"
            v-model="internalValue"
            :placeholder="placeholder"
            @input="handleInput"
            @focus="handleFocus"
            @blur="handleBlur"
            @click="onClick"
            ref="input"
            style="text-align: left"
            :disabled="isDisabled"
            required
        ></textarea>

        <label :for="id">
            {{ label }}
            <span style="margin-left: 5px">
                {{ required && !isDatetime ? ' *' : '' }}
            </span>
        </label>
        <i
            v-if="type == 'password'"
            @click="togglePasswordVisibility"
            :class="{ 'far fa-eye-slash': passwordVisible, 'far fa-eye': !passwordVisible }"
            :id="id"
            style="position: absolute; margin-left: -37px; margin-top: 25px; cursor: pointer"
        ></i>
        <span
            v-if="blured && focused != true && hasError && errorMessage"
            class="error-message"
            style="/*height: 25px;*/"
            >{{ errorMessage }}</span
        >

        <div v-if="isDisabled" class="input-disabled-div" @click="this.$refs.input.click()"></div>

        <div
            v-if="isTextInput && clearable"
            class="input-component-delete"
            :class="{ 'input-component-delete--active': internalValue }"
            role="button"
            title="Очистить"
            @click="handleValueDeleting"
        >
            <svg fill="#98A09F" width="32px" height="32px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M256,48C141.31,48,48,141.31,48,256s93.31,208,208,208,208-93.31,208-208S370.69,48,256,48Zm75.31,260.69a16,16,0,1,1-22.62,22.62L256,278.63l-52.69,52.68a16,16,0,0,1-22.62-22.62L233.37,256l-52.68-52.69a16,16,0,0,1,22.62-22.62L256,233.37l52.69-52.68a16,16,0,0,1,22.62,22.62L278.63,256Z"
                />
            </svg>
        </div>
    </div>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import tools from '@/assets/js/tools.js';

export default {
    name: 'CInput',
    components: {
        Datepicker,
    },
    props: {
        maxPercent: {
            type: Number,
            default: 0,
        },
        type: {
            type: String,
            default: 'text',
        },
        id: {
            type: String,
        },
        mask: {
            type: Function,
            default: (valueOld, valueNew) => {
                return valueNew;
            },
        },
        name: {
            type: String,
        },
        label: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        className: {
            type: String,
            default: 'forminput',
        },
        rows: {
            type: Number,
            default: 3,
        },
        validationFunction: {
            type: Function,
            default: () => {
                return { hasError: false, errorMessage: '' };
            },
        },
        localStorageKey: {
            type: String,
        },
        modelValue: {
            type: [String, Number],
        },
        required: {
            type: Boolean,
            default: false,
        },
        isTextarea: {
            type: Boolean,
            default: false,
        },
        isDatetime: {
            type: Boolean,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        onClick: {
            type: Function,
            default: () => {
                return;
            },
        },
        clearable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            internalValue: this.modelValue || '',
            internalValueDateTime: '',
            internalValueDate: '',
            internalValueTime: '',
            hasError: false,
            errorMessage: '',
            focused: false,
            blured: false,
            oldText: '',
            passwordVisible: false,
            tools: tools,
            hasEverChanged: false,
        };
    },
    computed: {
        isTextInput() {
            return !this.isTextarea;
        },
        inputType() {
            return this.passwordVisible ? 'text' : this.type;
        },
    },
    watch: {
        modelValue(newValue) {
            this.internalValue = newValue;
        },
        internalValueDateTime(newValue) {
            if (!newValue) {
                this.internalValue = '';
                this.internalValueDate = '';
                this.internalValueTime = '';
            } else {
                this.internalValueDate = tools.dateInString(newValue);
                this.internalValueTime = tools.timeInString(newValue);
                this.internalValue = newValue.toString();
            }
        },
        internalValue(newValue) {
            if (newValue) this.hasEverChanged = true;
            if (this.isDatetime) {
                this.internalValueDateTime = new Date(newValue);
            }
            if (newValue !== this.modelValue) {
                this.$emit('update:modelValue', newValue);
            }
            this.hasError = false;
            this.checkRequired();
        },
        maxPercent() {
            this.checkRequired();
        },
    },
    created() {
        this.isMobile = this.getMobileScreen();
    },
    mounted() {
        this.checkRequired();
    },
    unmounted() {
        this.$emit('error', { hasError: false, name: this.name, percent: 0 });
        this.$emit('completion', { percent: 0, name: this.name });
    },
    methods: {
        getMobileScreen() {
            if (screen.width <= 1024) {
                return true;
            } else {
                return false;
            }
        },
        togglePasswordVisibility() {
            this.passwordVisible = !this.passwordVisible;
        },
        handleFocus() {
            this.focused = true;
        },
        handleBlur() {
            this.blured = true;
            this.focused = false;
            this.checkRequired();
        },
        handleInput(event) {
            var maskedValue = this.mask(this.oldText, event.target.value);
            this.internalValue = maskedValue;
            this.oldText = maskedValue;
        },
        handleChange() {
            this.$emit('change');
        },
        handleValueDeleting() {
            this.$emit('clear');
            this.internalValue = '';
        },
        checkRequired() {
            if (this.required) {
                const isInputEmpty = !this.internalValue || !toString(this.internalValue).trim();

                if (this.validationFunction) {
                    const validationResult = this.validationFunction(this.internalValue);
                    this.hasError = isInputEmpty || validationResult.hasError;
                    this.errorMessage = isInputEmpty ? '' : validationResult.errorMessage;
                } else {
                    this.hasError = isInputEmpty;
                    this.errorMessage = '';
                }

                const completionPercentage = this.hasError || !this.hasEverChanged ? 0 : this.maxPercent;
                this.$emit('error', { hasError: this.hasError, name: this.name, percent: completionPercentage });
                this.$emit('completion', { percent: completionPercentage, name: this.name });
            } else {
                if (this.percentageAssigned) {
                    if (
                        this.hasError ||
                        (!this.hasError &&
                            (!this.internalValue || !Object.prototype.toString(this.internalValue).trim()))
                    ) {
                        const completionPercentage = 0;
                        this.$emit('completion', { percent: completionPercentage, name: this.name });
                        this.percentageAssigned = false;
                        return;
                    }
                }

                if (this.validationFunction) {
                    const validationResult = this.validationFunction(this.internalValue);
                    this.hasError = validationResult.hasError;
                    this.errorMessage = validationResult.errorMessage;
                }

                const completionPercentage = this.hasError || !this.hasEverChanged ? 0 : this.maxPercent;
                this.$emit('error', { hasError: this.hasError, name: this.name, percent: completionPercentage });
                this.$emit('completion', { percent: completionPercentage, name: this.name });
                if (!this.hasError) {
                    this.percentageAssigned = true;
                }
            }
        },
    },
};
</script>

<style scoped>
.error {
    border-color: var(--color-red) !important;
    border-width: 1px;
}
.error-message {
    position: absolute;
    display: flex;
    margin-top: 5px;
    color: var(--color-red);
}
.input-disabled-div {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

.input-component-datetime::v-deep .dp__clear_icon {
    display: none;
}
.input-component-datetime::v-deep input {
    height: 60px;
    color: white;
}
.input-component-datetime {
    max-width: 100px;
}
.input-component-datetime-date {
    margin-top: -16px;
    margin-left: 5px;
    font-size: 18px;
}
.input-component-datetime-time {
    margin-top: 16px;
    margin-left: 5px;
    font-size: 18px;
    color: var(--color-green);
    font-weight: 400;
}
.input-component-datetime-ico {
    position: absolute;
    margin-left: 154px;
    margin-top: -48px;
    width: 32px;
    cursor: pointer;
    pointer-events: none;
}

.input-component-delete {
    display: block;
    position: absolute;
    top: 19px;
    right: 8px;
    cursor: pointer;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.25s ease-in-out;
}

.input-component-delete--active {
    opacity: 1;
    visibility: visible;
}

@media (max-width: 1024px) {
    .input-component-datetime-ico {
        margin-left: calc(100% - 60px);
    }
}
</style>
